import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import Loader from './Loader';

const ProtectedRoute = ({ component: Component, showRoute, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (showRoute === undefined || showRoute === null) {
        return <Loader />;
      }
      return showRoute ? <Component {...props} /> : (<Redirect to="/404" />);
    }}
  />
);

ProtectedRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func
  ]),
  showRoute: PropTypes.bool
};

export default ProtectedRoute;
